import React from "react";

const TemplateCardSkeleton: React.FC = () => {
  return (
    <div
      data-testid="skeleton-card"
      className="py-3 px-3 bg-gray-50 rounded-lg border border-gray-300 flex flex-col hover:bg-gray-100 transition-shadow cursor-pointer relative animate-pulse"
    >
      {/* Dropdown Button (top right) */}
      <div className="absolute top-3 right-2">
        <div className="w-4 h-4 2xl:w-5 2xl:h-5 bg-gray-300 rounded-full" />
      </div>

      {/* Date */}
      <div className="h-[18px] 2xl:h-[1rem] w-20 bg-gray-300 rounded mb-4" />

      {/* Title */}
      <div className="h-[1.25rem] 2xl:h-[1.5rem] w-3/4 bg-gray-400 rounded mb-2" />

      {/* Description (2 lines, fixed height) */}
      <div className="w-full bg-gray-300 rounded mb-2 h-[2.25rem] 2xl:h-[2.5rem] mt-[10px]" />

      {/* Created By */}
      <div className="h-[0.875rem] 2xl:h-[1rem] w-32 bg-gray-300 rounded mt-[0.375rem] 2xl:mt-3 " />
    </div>
  );
};

export default TemplateCardSkeleton;
